import React from "react";
import {QCDashboardData} from "./QCDashboardData";
import QCDashboardContextProvider from "../../commons/context/QCDashboardContext";

const QCDashboard = () => {
    return (
        <QCDashboardContextProvider>
            <QCDashboardData/>
        </QCDashboardContextProvider>
    );
};

export default QCDashboard;



// WEBPACK FOOTER //
// ./src/components/qcDashboard/QCDashboard.js